import * as React from 'react';

const PriceTagSmall = () => (
  <svg
    width={58}
    height={47}
    viewBox="0 0 58 47"
    strokeWidth={1}
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path
      stroke="none"
      fill="#677BC5"
      d="M37.308,10.785 C35.789,10.653 34.666,9.314 34.798,7.795 C34.931,6.276 36.27,5.153 37.789,5.286 C39.308,5.419 40.431,6.757 40.298,8.276 C40.166,9.795 38.827,10.918 37.308,10.785 M45.159,16.248 L43.613,6.739 C42.92,3.662 40.049,1.579 36.909,1.876 L27.389,3.358 C25.596,3.527 23.962,4.459 22.905,5.917 L6.221,28.917 C5.444,29.988 5.682,31.485 6.753,32.262 L24.088,44.837 C25.159,45.614 26.656,45.376 27.433,44.305 L44.117,21.305 C45.175,19.848 45.555,18.005 45.159,16.248"
    />
    <path
      stroke="none"
      fill="#3A427C"
      d="M37.815,5.355 C39.333,5.488 40.457,6.827 40.324,8.345 C40.191,9.864 38.852,10.987 37.334,10.854 C35.815,10.721 34.691,9.383 34.824,7.864 C34.957,6.345 36.296,5.222 37.815,5.355 L37.815,5.355 Z M38.488,29.17 L43.389,22.414 C43.41,22.219 43.431,22.025 43.436,21.828 L44.273,11.877 C44.274,11.862 44.274,11.848 44.275,11.833 C44.361,8.194 41.712,5.037 38.114,4.49 C38.099,4.488 38.084,4.486 38.069,4.484 L28.125,3.581 C27.691,3.516 27.257,3.5 26.825,3.514 C25.267,3.813 23.871,4.69 22.931,5.986 L6.246,28.986 C5.47,30.057 5.708,31.554 6.778,32.331 L21.765,43.202 L38.488,29.17 Z"
      opacity={0.2}
    />
    <path
      strokeWidth={2}
      d="M37.308,10.785 C35.789,10.653 34.666,9.314 34.798,7.795 C34.931,6.276 36.27,5.153 37.789,5.286 C39.308,5.419 40.431,6.757 40.298,8.276 C40.166,9.795 38.827,10.918 37.308,10.785 Z M45.159,16.248 L43.613,6.739 C42.92,3.662 40.049,1.579 36.909,1.876 L27.389,3.358 C25.596,3.527 23.962,4.459 22.905,5.917 L6.221,28.917 C5.444,29.988 5.682,31.485 6.753,32.262 L24.088,44.837 C25.159,45.614 26.656,45.376 27.433,44.305 L44.117,21.305 C45.175,19.848 45.555,18.005 45.159,16.248 Z"
    />
    <path
      stroke="none"
      fill="#FFFFFF"
      d="M39.646,10.006 C40.724,8.928 40.724,7.18 39.646,6.102 C38.568,5.024 36.821,5.024 35.743,6.102 C34.665,7.18 34.665,8.928 35.743,10.006 C36.821,11.084 38.568,11.084 39.646,10.006 Z"
    />
    <path d="M39.646,10.006 C40.724,8.928 40.724,7.18 39.646,6.102 C38.568,5.024 36.821,5.024 35.743,6.102 C34.665,7.18 34.665,8.928 35.743,10.006 C36.821,11.084 38.568,11.084 39.646,10.006 Z" />
    <path
      stroke="none"
      fill="#FFFFFF"
      d="M39.646,10.005 C38.568,11.084 36.821,11.084 35.743,10.005 C34.665,8.928 34.665,7.18 35.743,6.102 C36.821,5.024 38.568,5.024 39.646,6.102 C40.724,7.18 40.724,8.928 39.646,10.005 M43.985,17.885 L43.951,7.878 C43.743,4.61 41.138,2.005 37.87,1.796 L27.863,1.763 C25.996,1.644 24.168,2.334 22.846,3.656 L1.978,24.524 C1.007,25.495 1.007,27.07 1.978,28.042 L17.706,43.769 C18.678,44.741 20.253,44.741 21.224,43.769 L42.092,22.902 C43.414,21.579 44.104,19.752 43.985,17.885"
    />
    <path
      strokeWidth={2}
      d="M39.646,10.005 C38.568,11.084 36.821,11.084 35.743,10.005 C34.665,8.928 34.665,7.18 35.743,6.102 C36.821,5.024 38.568,5.024 39.646,6.102 C40.724,7.18 40.724,8.928 39.646,10.005 Z M43.985,17.885 L43.951,7.878 C43.743,4.61 41.138,2.005 37.87,1.796 L27.863,1.763 C25.996,1.644 24.168,2.334 22.846,3.656 L1.978,24.524 C1.007,25.495 1.007,27.07 1.978,28.042 L17.706,43.769 C18.678,44.741 20.253,44.741 21.224,43.769 L42.092,22.902 C43.414,21.579 44.104,19.752 43.985,17.885 Z"
    />
    <path d="M26.29,5.293 L40.455,19.458" />
    <path
      stroke="none"
      fill="#677BC5"
      d="M21.551,37.015 L19.962,35.426 C17.615,37.208 15.135,36.688 13.739,35.56 L15.135,33.273 C16.16,34.119 17.645,34.357 19.011,32.99 C19.977,32.025 20.081,31 19.427,30.346 C18.923,29.842 18.165,29.827 17.259,30.406 L15.596,31.476 C13.635,32.723 11.63,32.708 10.204,31.282 C8.63,29.708 8.69,27.332 10.026,25.49 L8.437,23.901 L9.952,22.386 L11.586,24.02 C13.605,22.624 15.536,23.069 16.739,23.856 L15.432,26.203 C14.823,25.772 13.575,25.297 12.357,26.515 C11.407,27.465 11.437,28.535 12.046,29.144 C12.506,29.604 13.219,29.664 14.066,29.114 L15.729,28.074 C18.016,26.619 19.977,26.886 21.313,28.223 C22.68,29.589 22.962,31.832 21.462,33.897 L23.066,35.501 L21.551,37.015 Z"
    />
    <path d="M22.694,25.612 L32.248,16.058" />
    <path d="M27.81,30.728 L37.364,21.174" />
    <path d="M25.252,28.17 L34.806,18.616" />
    <path d="M20.136,23.054 L29.69,13.5" />
    <path d="M17.578,20.496 L27.132,10.942" />
    <path d="M15.02,17.938 L24.574,8.384" />
    <path
      strokeWidth={2}
      d="M37.903,7.428 C37.903,7.428 39.073,2.416 45.613,1.964 C52.928,1.458 55.917,6.998 56.47,12.375 C57.917,26.447 46.288,29.06 49.143,40.053 C49.143,40.053 50.449,44.608 54.476,45.141"
    />
  </svg>
);

export default PriceTagSmall;



// WEBPACK FOOTER //
// ./src/assets/images/icons/price-tag-small.js